<div *ngIf="userSignedIn && signInChecked">
  <app-navbar *ngIf="showNavbar"></app-navbar>
  <router-outlet> </router-outlet>
</div>
<div *ngIf="!userSignedIn && signInChecked" class="py-5 my-5">
  <div class="card mx-auto my-5 border border-primary" style="width: 30rem">
    <h3 class="card-header bg-primary border border-primary text-center text-white">Prince Law Offices</h3>
    <div class="card-body">
      <app-form-group>
        <app-form-label>Username</app-form-label>
        <app-form-text-input
          (keyupEnter)="signIn()"
          [disabled]="signingIn"
          [autofocus]="true"
          inputName="username"
          [(model)]="signInParams.username"
        ></app-form-text-input>
      </app-form-group>
      <app-form-group>
        <app-form-label>Password</app-form-label>
        <app-form-text-input
          type="password"
          (keyupEnter)="signIn()"
          [disabled]="signingIn"
          inputName="password"
          [(model)]="signInParams.password"
        ></app-form-text-input>
      </app-form-group>
      <app-form-group>
        <app-form-checkbox
          [(model)]="signInParams.remember_me"
        ></app-form-checkbox>
      </app-form-group>
      <app-form-group>
        <app-button [block]="true" [disabled]="signingIn" (onClick)="signIn()">
          <app-loading-text
            loadingText="Signing In"
            nonLoadingText="Sign In"
            [loading]="signingIn"
          ></app-loading-text>
        </app-button>
      </app-form-group>
    </div>
  </div>
</div>
<app-modal-confirm #confirmModal></app-modal-confirm>
<app-confirm-dialog #confirmDialog></app-confirm-dialog>
<app-alert-dialog #alertDialog></app-alert-dialog>
<app-phone-call-billing-modal></app-phone-call-billing-modal>
<span class="ti-close d-none"></span>

<ng-template #lateReasonModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Late arrival explanation</h4>
  </div>
  <div class="modal-body">
    <p>
      Your staff attendance was recorded at <strong>{{ lateNotice?.signed_in_at }}</strong>,
      after your scheduled start of <strong>{{ lateNotice?.scheduled_start }}</strong>.
      This creates <strong>{{ lateNotice?.late_minutes }} unpaid minute{{ lateNotice?.late_minutes === 1 ? '' : 's' }}</strong>.
    </p>
    <label for="late-arrival-reason">Please explain why you were late:</label>
    <textarea id="late-arrival-reason" class="form-control" rows="4" [(ngModel)]="lateReason" [disabled]="savingLateReason"></textarea>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveLateReason(modal)" [disabled]="savingLateReason || !lateReason.trim()">
      {{ savingLateReason ? 'Saving…' : 'Save explanation' }}
    </button>
    <button type="button" class="btn btn-outline-secondary" (click)="dismissLateReason(modal)" [disabled]="savingLateReason">Not now</button>
  </div>
</ng-template>
<script src="//openweathermap.org/themes/openweathermap/assets/vendor/owm/js/d3.min.js"></script>
<iframe id="breadcrumb_poster" style="display: none"> </iframe>
